import { render, staticRenderFns } from "./TableSwitch.vue?vue&type=template&id=0f5bf20a&scoped=true"
import script from "./TableSwitch.vue?vue&type=script&lang=ts"
export * from "./TableSwitch.vue?vue&type=script&lang=ts"
import style0 from "./TableSwitch.vue?vue&type=style&index=0&id=0f5bf20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5bf20a",
  null
  
)

export default component.exports